// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__e-88L","label":"LabeledBox_label__25I6u"};